import React from 'react';
import ReactDOM from 'react-dom';
import './less/index.less';
import App from './App';
import * as serviceWorker from './serviceWorker';

// ATTENTION!! Usage of StrictMode can throws errors / warnings
// https://github.com/ant-design/ant-design/issues/22493
// https://reactjs.org/docs/strict-mode.html
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
